module.exports = __webpack_public_path__ + "static/img-test-chairis-bd7f39bd38997779d7bb22934e664648.jpg";